import React, { useState } from "react";
import { BsCloudDownload } from "react-icons/bs";
import { Button } from "antd";
import { useGlobalDownloader } from '../../../context/global/DownloadProvider';

const DowloadAllReplyComment = ({ currentComment }) => {
  const [isActionDisabled, setIsActionDisabled] = useState(false);
  const { startDownload } = useGlobalDownloader();

  const handleDownloadAll = () => {
    const filesToDownload = currentComment?.attachFiles;
    if (!filesToDownload || filesToDownload.length === 0) {
      return;
    }

    // Tải tất cả các file cùng lúc
    filesToDownload.forEach((file) => {
      startDownload(file.resourceId, file.originalName || file.fileName);
    });

    setIsActionDisabled(true);
    setTimeout(() => setIsActionDisabled(false), 2000);
  };

  return (
    <Button
      type="text"
      disabled={isActionDisabled}
      color={isActionDisabled ? "#ccc" : "#2b9853"}
      onClick={handleDownloadAll}
    >
      <BsCloudDownload className="text-[20px]" />
    </Button>
  );
};

export { DowloadAllReplyComment };

